import { Link } from 'react-router-dom';

const pillars = [
  { icon: 'ri-flashlight-line', label: 'Diagnostic en 48h' },
  { icon: 'ri-team-line', label: 'Réseau privé' },
  { icon: 'ri-user-star-line', label: 'Experts dédiés' },
  { icon: 'ri-shield-check-line', label: 'Accompagnement réel' },
];

const CtaSection = () => {
  return (
    <section className="bg-[#0D1228] py-24 px-6 border-t border-white/[0.07]">
      <div className="max-w-3xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#C9A227]/10 border border-[#C9A227]/20 rounded-full mb-8">
          <i className="ri-time-line text-[#C9A227] text-xs"></i>
          <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">Ne traverse pas ça seul</span>
        </div>

        <h2 className="text-3xl md:text-5xl font-black text-white mb-5 leading-tight">
          Tu es au bon endroit.<br />
          <span className="text-[#C9A227]">Rejoins-nous maintenant.</span>
        </h2>

        <p className="text-white/40 text-base mb-10 max-w-lg mx-auto leading-relaxed">
          Plus de 120 sportifs ont déjà fait le premier pas.
          Ton projet mérite les bons interlocuteurs, la bonne méthode et le bon réseau.
        </p>

        {/* Pillars */}
        <div className="flex flex-wrap justify-center gap-3 mb-10">
          {pillars.map((p, i) => (
            <div key={i} className="flex items-center gap-2 px-3 py-2 bg-white/[0.04] border border-white/[0.07] rounded-lg">
              <i className={`${p.icon} text-[#C9A227] text-sm`}></i>
              <span className="text-white/60 text-xs font-medium whitespace-nowrap">{p.label}</span>
            </div>
          ))}
        </div>

        <Link
          to="/auth/signup"
          className="inline-flex items-center gap-2.5 px-10 py-4 bg-[#C9A227] text-[#080C1E] font-black text-base rounded-xl hover:bg-[#D4B84A] transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-user-add-line text-lg"></i>
          Créer mon compte gratuitement
        </Link>

        <p className="mt-5 text-white/20 text-xs">
          Accès sur candidature · Inscription rapide · Aucune CB requise
        </p>
      </div>
    </section>
  );
};

export default CtaSection;
